import { CardType, ComponentType } from "../../data";
import { getAvailableFixtureMarket } from "../getAvailableFixtureMarket";
import { getAvailableOutrightMarket } from "../getAvailableOutrightMarket";
export const getCardPropsMarkets = (event, markets, sport) => {
    if (event.cardType === CardType.Regular) {
        return [getAvailableFixtureMarket(event.id, event.isLive, markets, sport)];
    }
    if (event.componentType === ComponentType.LiveOutright
        || event.componentType === ComponentType.PreliveOutright) {
        return [getAvailableOutrightMarket(event.id, markets)];
    }
    return markets;
};
//# sourceMappingURL=getCardPropsMarkets.js.map